"use client";

import { FC, useMemo } from "react";
import { AssetsDirectory, TranslationScopes } from "@finbackoffice/enums";
import { SportTypesBC } from "@finbackoffice/fe-core";
import Translate from "components/base/translate/Translate";
import SportIcon from "components/base/sport-icon/SportIcon";
import { Svg } from "components/base/svg/Svg";
import styles from "../../policies.module.sass";

type Props = {
    scope: string;
};

const PoliciesSportsbookContentBC: FC<Props> = ({ scope }) => {
    if (!scope) {
        return null;
    }

    const name = useMemo(() => scope[0]?.toUpperCase()?.replace(/-/g, "_"), [scope]);
    const isSport = useMemo(() => Object.keys(SportTypesBC).includes(name), [name]);

    return (
        <>
            <div className={styles.subHeader}>
                {isSport ? (
                    <SportIcon sportId={SportTypesBC[name as keyof typeof SportTypesBC]} />
                ) : (
                    <Svg
                        src={`/${AssetsDirectory.Common}/${AssetsDirectory.Mobile}/${AssetsDirectory.BaseIcons}/policies-${scope}.svg`}
                        className="svg-sport-icon"
                        loader
                    />
                )}
                <h2>
                    <Translate
                        tid={`bc_sportrules_${name}_title`}
                        namespace={TranslationScopes.PoliciesSportsbook}
                    />
                </h2>
            </div>
            <div className={styles.content}>
                <Translate
                    tid={`bc_sportrules_${name}`}
                    dangerous
                    namespace={TranslationScopes.PoliciesSportsbook}>
                    <div />
                </Translate>
            </div>
        </>
    );
};

export default PoliciesSportsbookContentBC;
